import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import useLocales from '../../hooks/useLocales';
import useCoBranding from './useCoBranding';
import CoBrandingSeparator from './CoBrandingSeparator';

/**
 * The sidebar lockup for co-branded clients: our logo × the carrier's full logo.
 * Renders nothing without co-branding, so callers keep their usual logo then.
 */
const CoBrandingNavLogo: FC = () => {
    const { translate } = useLocales();
    const { coBranding, colors } = useCoBranding();

    if (!coBranding || !colors) return null;

    return (
        <Stack
            component={RouterLink}
            to="/auth/login"
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{ minWidth: 0 }}
        >
            <Box component="img" src="/favicon/Reachlink_Logo_VF_B.svg" alt="ReachLink Logo" sx={{ width: 110, height: 16, flexShrink: 0 }} />
            <Box sx={{ display: 'flex', flexShrink: 0 }}>
                <CoBrandingSeparator size={8} start={colors.start} end={colors.end} />
            </Box>
            <Box
                component="img"
                src={coBranding.logoUrl}
                alt={translate('components.coBranding.logoAlt', { carrier: coBranding.carrierName })}
                sx={{ height: 16, maxWidth: 64, objectFit: 'contain', minWidth: 0 }}
            />
        </Stack>
    );
};

export default CoBrandingNavLogo;
